import { IaqoboAirPermission } from "app_locobook/shared/iaqobo-air-permission.enum";
import { IWenji } from "libraries/interfaces/IWenji";
import { Yii, IYii } from "libraries/interfaces/Yii";
import { ILabels } from 'libraries/interfaces/ILabels';
import { IDropOption, cabinClassesList, maxViasList } from 'libraries/module/formbuilder/forms/searchAirTrip/searchAirTrip.component';
import { IMomentDateFormat } from 'libraries/interfaces/IMomentDateFormat';
import { IPrice, IQuantity, IFlexibility, ISegment } from 'libraries/interfaces/i-post-air-search-request';
import { Component, Input, OnInit } from '@angular/core';
import {
    faArrowRight,
    IconDefinition,
    faStar,
    faCheck,
    faBan,
    faSuitcase
} from "@fortawesome/free-solid-svg-icons";

declare const wenji: IWenji;

class Wording {
    public readonly nextDay: string = Yii.t('wui-iqba-js', 'lendemain');
    public readonly departure: string = Yii.t('wui-iqba-js', 'départ');
    public readonly arrival: string = Yii.t('wui-iqba-js', 'arrivée');
    public readonly before: string = Yii.t('wui-iqba-js', 'avant');
    public readonly after: string = Yii.t('wui-iqba-js', 'après');
    public readonly from: string = Yii.t('wui-iqba-js', 'de');
    public readonly at: string = Yii.t('wui-iqba-js', 'à');
    public readonly stopoverTime: string = Yii.t("wui-iqba-js", "temps d'escale maximum");
    public readonly travellers: string = Yii.t("wui-iqba-js", "Voyageurs");
    public readonly adt: string = Yii.t("wui-iqba-js", "ADT");
    public readonly chd: string = Yii.t("wui-iqba-js", "CHD");
    public readonly inf: string = Yii.t("wui-iqba-js", "INF");
    public readonly priceForAdt: string = Yii.t("wui-iqba-js", "Prix par ADT");
    public readonly moreAndLess: string = Yii.t("wui-iqba-js", "+/- ");
    public readonly typeTariff: string = Yii.t("wui-iqba-js", "Types de tarif");
    public readonly companies: string = Yii.t("wui-iqba-js", "Compagnies");
    public readonly favoriteCompanies: string = Yii.t("wui-iqba-js", "Compagnies préférées");
    public readonly incluedCompanies: string = Yii.t("wui-iqba-js", "Compagnies incluses");
    public readonly excludedCompanies: string = Yii.t("wui-iqba-js", "Compagnies exclues");
    public readonly includedServices: string = Yii.t("wui-iqba-js", "Services Inclus");
    public readonly days: string = Yii.t("wui-iqba-js", "Jours");
    public readonly day: string = Yii.t("wui-iqba-js", "Jour");
    public readonly source: string = Yii.t("wui-iqba-js", "Source");
    public readonly sources: string = Yii.t("wui-iqba-js", "Sources");
    public readonly arrivalAt: string = Yii.t("wui-iqba-js", "arrivée le ");
}

@Component({
    selector: 'abstractCard',
    templateUrl: './abstractCard.component.html',
    styleUrls: ['./abstractCard.component.scss']
})
export class AbstractCardComponent implements OnInit {
    @Input()
    public segment: ISegment[];

    @Input()
    public carrier: {
        preferred: string[];
        exclude: string[];
        include: string[];
    };

    @Input()
    public price: IPrice;

    @Input()
    public quantity: IQuantity;

    @Input()
    public keyword: string;

    @Input()
    public host: string;

    @Input()
    public flexibility: IFlexibility;

    @Input()
    public locator: string;

    public wording: Wording = new Wording();

    @Input()
    public fullServiceCarriersOnly: boolean;

    public iconArrowRight: IconDefinition = faArrowRight;

    public iconCheck: IconDefinition = faCheck;

    public iconStar: IconDefinition = faStar;

    public iconBan: IconDefinition = faBan;

    public readonly permission: typeof IaqoboAirPermission = IaqoboAirPermission;

    public Yii: IYii = Yii;
    public dateFormat: IMomentDateFormat = JSON.parse(wenji.ui.dateFormat);

    public labels: ILabels = {
        locator: Yii.t('wui-iqba-js', 'Agence'),
        cabin: Yii.t('wui-iqba-js', 'classe cabine'),
        maxVias: Yii.t('wui-iqba-js', "nombre d'escales maximum"),
        onlyAirport: Yii.t('wui-iqba-js', "(Aéroport uniquement)"),
        fullServiceCarriersOnly: Yii.t('wui-iqba-js', "Hors LCC"),
    };

    public keywordDisplay: {
        LuggageInHold: {
            icon: string;
            iconDefinition: IconDefinition,
            label: string;
        }
    } = {
        LuggageInHold: {
            icon: 'fa-suitcase',
            iconDefinition: faSuitcase,
            label: Yii.t('wui-iqba-js', 'bagages enregistrés')
        }
    };

    public cabin: string;
    public maxVias: string;
    public maxViasAndCabinArray: { maxVias: number, maxViasToDisplay: string, cabin: string, cabinToDisplay: string }[] = [];

    public ngOnInit(): void {
        this.segment.forEach((segmentData: ISegment) => {
            let maxViasData: string = "";
            let cabinData: string = "";
            if (segmentData.maxVias >= 0) {
                const relatedVia: IDropOption = maxViasList.find((maxVia: IDropOption): boolean => segmentData.maxVias === maxVia.value);
                if (relatedVia) {
                    maxViasData = relatedVia.label;
                }
            }
            if (segmentData.cabin) {
                const relatedCabinClass: IDropOption = cabinClassesList.find((cabinClass: IDropOption): boolean => segmentData.cabin === cabinClass.value);
                if (relatedCabinClass) {
                    cabinData = relatedCabinClass.label;
                }
            }
            return this.maxViasAndCabinArray.push({
                maxVias: segmentData.maxVias,
                maxViasToDisplay: maxViasData,
                cabin: segmentData.cabin,
                cabinToDisplay: cabinData
            });
        });
    }
}
